export const PDF_EXPORT_QUERY_PARAM_EXPORT_MODE = 'exportMode';
export const PDF_EXPORT_QUERY_PARAM_EXPORT_TARGET = 'exportTarget';
export const PDF_EXPORT_QUERY_PARAM_EXPORT_TAB = 'exportTab';
